import Select from "react-select";
import { Async } from "react-select";
var extend = require('./Helper').extend;

function getAsyncOptions(settings)
{
    return (input) => {
        if (!input) {
            return Promise.resolve(settings);
        }

        return fetch(settings.searchUrl + input)
            .then((response) => response.json())
            .then((json) => {
                return extend(settings, { options: json });
            });
    };
}

export class AsyncDropdown extends React.Component {
    constructor(props) {
        super();
        this.state = {
            options: [],
            value: null
        };
    }

    onInputChange(option) {
        this.getOptionsAsync(option);
    }

    // We expect results to be returned in [{value: '', label: ''},...] format
    getOptionsAsync(newInput) {
        var self = this;
        fetch(this.props.options.searchUrl + newInput)
            .then((response) => response.json())
            .then((json) => {
                self.setState({
                    options: json ? json : []
                });
            });
    }

    componentDidMount() {
        this.updateFromUrl();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.url !== this.props.url) {
            this.updateFromUrl();
        }
    }

    updateFromUrl() {
        if (!this.props.options.searchUrl) {
            var self = this;
            fetch(this.props.url)
                .then((response) => response.json())
                .then((json) => {
                    self.setState({
                        options: json ? json : []
                    });
                });
        } 
    }

    render() {
        if (this.props.options.searchUrl) {
            return (
                <Select
                    onInputChange={this.onInputChange.bind(this)}
                    options={this.state.options || []}
                    value={this.props.value}
                    isClearable
                    onChange={this.props.onChange.bind(this)}
                    {...this.props.options}/>
            );
        } else {
            return (
                <Select
                    options={this.state.options || []}
                    value={this.props.value}
                    isClearable
                    onChange={this.props.onChange.bind(this)}
                    {...this.props.options} />
            );
        }
        
    }
}